import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import { SOCIETY_MANAGE_EMPLOYEES } from '../../../Routing/routes';
import ManageEmployeeListLayer from './Component/ManageEmployeeListLayer';
import './ManageEmployee.css';

const ManageEmployee = () => {
    const links = [{ to: SOCIETY_MANAGE_EMPLOYEES, text: 'Manage Employees' }];
    return (
        <div className="emp-page">
            <Breadcrumb
                replaceClass="mb-24"
                description="Cross-society employee directory"
                links={links}
                headingTitle="Manage Employees"
            />
            <ManageEmployeeListLayer />
        </div>
    );
};

export default ManageEmployee;
